import YvooaIcon from "./logo/YvooaIcon";

const Footer = ({ className = "", classNamePrivacyPolicy = "" }) => {
  return (
    <footer
      className={`w-full bg-transparent dark:bg-transparent ${className}`}
      id="yvooaRightsFooter"
      name="footer-text"
      data-cy="footer-text"
    >
      <div className="mx-auto w-full px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
        <div className="flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-2 text-gray-500/100 dark:text-gray-400/100">
          <div className="flex items-center gap-2">
            <YvooaIcon size={22} className="text-blue-500 dark:text-blue-300" />
            <span className="text-xs sm:text-sm">
              © YVOOA {new Date().getFullYear()} All Rights Reserved.
            </span>
          </div>
          <a
            href="https://www.yvooa.com/privacy-policy/"
            id="yvooaRightLink"
            className={`${classNamePrivacyPolicy} text-blue-600 dark:text-blue-400 underline text-xs sm:text-sm`}
            target="_blank"
            rel="noopener noreferrer"
            data-cy="privacy-policy-link"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
